import React from "react";
import { Link } from "react-router-dom";
import { useTransaction } from "wagmi";

export default function StakingSuccess({ pepecoinStaked, brainsEarned, hash }) {
  const result = useTransaction({
    hash: hash,
  });

  return (
    <div className="thank-you text-center">
      <svg
        width="24"
        height="17"
        viewBox="0 0 24 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.96777 10.4862L7.18718 14.6617C8.41167 15.6413 10.1876 15.4961 11.2367 14.3305L22.689 1.60571"
          stroke="url(#paint0_linear_290_688)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_290_688"
            x1="12.3284"
            y1="1.60571"
            x2="12.3284"
            y2="15.3105"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#75FBFD" />
            <stop offset="1" stopColor="#75FBFD" stopOpacity="0.44" />
          </linearGradient>
        </defs>
      </svg>
      <small className="font-mono text-uppercase d-block my-4">
        YOU SUCCESSFULLY STAKED{" "}
        <span className="text-blue">{pepecoinStaked.toLocaleString()}</span>{" "}
        PEPECOIN <br />
        FOR{" "}
        <span className="text-blue">
          {brainsEarned} BRAIN{brainsEarned !== 1 ? "S" : ""}
        </span>
      </small>
      <div>
        <Link
          to="/my-inventory"
          className="button align-items-center d-flex justify-content-center"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12.3574" cy="12.0234" r="12" fill="black" />
            <path
              d="M12.3574 8.78125L14.9508 12.023L12.3574 15.2647"
              stroke="#75FBFD"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="ps-3">Go to My Inventory</span>
        </Link>
      </div>
    </div>
  );
}
